import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { faFilter } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-show-filter-button',
  template: `
    <button type="button" class="button-secondary d-flex align-items-center gap-2" (click)="toggleFilters()">
      <fa-icon [icon]="filterIcon" size="lg"></fa-icon>
      {{ 'action.filter' | transloco }}
      <span class="text-danger" *ngIf="howManyFiltersApplied">/ {{ howManyFiltersApplied }}</span>
    </button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShowFilterButtonComponent {
  @Output() showFiltersStatus = new EventEmitter<boolean>(false);
  @Input() howManyFiltersApplied = 0;
  filterIcon = faFilter;
  private showFilters = false;

  toggleFilters(): void {
    this.showFilters = !this.showFilters;
    this.showFiltersStatus.emit(this.showFilters);
  }
}
